import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.1723 2.91669C12.2828 2.91669 12.3888 2.96059 12.467 3.03873L14.824 5.39575C14.9867 5.55847 14.9867 5.82229 14.824 5.985L7.16365 13.6453C7.11131 13.6977 7.04596 13.7351 6.97433 13.7538L3.78397 14.5872C3.64085 14.6246 3.48864 14.5833 3.38404 14.4787C3.27945 14.3741 3.23815 14.2219 3.27553 14.0787L4.10886 10.8884C4.12757 10.8167 4.16503 10.7514 4.21738 10.699L11.8777 3.03873C11.9558 2.96059 12.0618 2.91669 12.1723 2.91669Z"
      fill="#7876C1"
    />
    <path
      d="M3.3335 16.0417C2.98832 16.0417 2.7085 16.3215 2.7085 16.6667C2.7085 17.0119 2.98832 17.2917 3.3335 17.2917H15.8335C16.1787 17.2917 16.4585 17.0119 16.4585 16.6667C16.4585 16.3215 16.1787 16.0417 15.8335 16.0417H3.3335Z"
      fill="#7876C1"
    />
  </svg>
);

const EditIcon3 = (props) => <Icon component={svg} {...props} />;

export default EditIcon3;
